import React, { useState } from "react";
import {
    Modal,
    Button,
    Form,
    InputNumber,
    Space,
    notificationProvider,
    useModalForm,
} from "@pankod/refine-antd";
import { ICompany } from "interfaces";

interface ManageTrialLimitsModelProps {
    refetchCompanyDetail: (shouldRefetch: boolean) => void;
    companyId: string;
    companyDetail: ICompany;
}

export const ManageTrialLimitsModel: React.FC<ManageTrialLimitsModelProps> = ({
    refetchCompanyDetail,
    companyId,
    companyDetail
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const {
        modalProps,
        formProps,
        show: showModal,
        close: closeModal,
    } = useModalForm<any>({
        resource: "configureCompanyTrialLimit",
        dataProviderName: "grapghQl",
        action: "create",
        redirect: false,
        submitOnEnter: false,
        metaData: {
            input: {
                companyId: companyId,
                key: "INVOICE_AP_PROCESSING_LIMIT",
            }
        },
        onMutationSuccess(data: any) {
            notificationProvider.open({
                message: "Success",
                description: "Trial limit configured successfully",
                type: "success",
            });
            refetchCompanyDetail(true);
            closeModal();
            setIsModalVisible(false);
        },
        onMutationError(error: any) {
            notificationProvider.open({
                message: "Error",
                description: error?.message || "Failed to configure trial limit",
                type: "error",
            });
        }
    });

    modalProps.title = 'Configure Trial Limits';
    modalProps.centered = true;
    modalProps.width = 500;
    modalProps.onOk = async () => {
        try {
            await formProps.form?.validateFields();
            formProps.form?.submit();
        } catch (error) {
            console.error('Form validation error:', error);
        }
    };

    modalProps.afterClose = () => {
        formProps.form?.resetFields();
        setIsModalVisible(false);
    };

    const handleShowModal = () => {
        setIsModalVisible(true);
        showModal();

        // Set initial value from company detail if available
        const currentLimit = companyDetail?.companyLimitsForTrial?.find(
            item => item.key === 'INVOICE_AP_PROCESSING_LIMIT'
        );

        if (currentLimit) {
            formProps.form?.setFieldsValue({
                maxLimit: currentLimit.limit,
            });
        }
    };

    return (
        <>
            <Button
                type="primary"
                onClick={handleShowModal}
            >
                Configure Trial Limits
            </Button>

            <Modal {...modalProps} visible={isModalVisible} onCancel={() => {
                closeModal();
                setIsModalVisible(false);
            }}>
                <Form {...formProps} layout="vertical">
                    <Form.Item
                        label="Invoice AP Processing Limit"
                        name="maxLimit"
                        rules={[
                            { required: true, message: 'Please enter trial limit' },
                            { type: 'number', min: 1, message: 'Limit must be at least 1' }
                        ]}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            placeholder="Enter maximum limit"
                            min={1}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
